import { useNavigate, useOutletContext, useParams } from 'react-router-dom'
import { launchLab } from '../../lib/Funcs/LabWorkspace'
import { useEffect, useState } from 'react'
import { StatusCircleIcon } from '../../lib/assets/icons/SVG-Icons'

const checkSameId = (localId, counterID) => {
  return localId === counterID
}

const SingleLabCard = ({ lab, index }) => {
  const navigate = useNavigate()
  const { checkAccessByPlanId } = useOutletContext()
  const { plan, planId } = useParams()
  const [hasAccessToLab, setHasAccessToLab] = useState(false)

  const counterID = lab?._id
  const configId = lab?.vm_type || null
  const isConfigSet = configId !== null
  const labGroupID = lab?.subscription_plan_id?._id || planId
  const moduleID = lab?.module_id || null

  const isLabLaunching = localStorage.getItem('startingLabData') || false
  const isLabRunning = localStorage.getItem('runningLabData') || false

  const labData = {
    configId: configId,
    counterID: counterID,
    labGroupID: labGroupID,
    moduleID: moduleID,
    labId: counterID,
    duration: parseInt(lab?.duration),
  }

  function handleNavigateToPricing() {
    navigate('/subscription/pricing')
  }

  const localLaunchingLab = JSON.parse(isLabLaunching)
  const localRunningLab = JSON.parse(isLabRunning)

  const isThisLabRunning = checkSameId(localRunningLab?.labId, counterID)

  const isThisLabLaunching = checkSameId(localLaunchingLab.counterID, counterID)

  async function handleStartLab() {
    if (isLabLaunching) {
      if (isThisLabLaunching && isThisLabRunning && isLabRunning) {
        return navigate(`/launch/playground/subscribed/${labGroupID}/${moduleID}/${lab._id}`)
      } else if (isThisLabLaunching) return navigate('/subscription/lab-loading')
    }

    return launchLab(navigate, labData, true)
  }

  const handleLabClick = () => {
    if (!isConfigSet) {
      alert('Configuration not set. Contact admin.')
      return
    }
    handleStartLab()
  }

  useEffect(() => {
    setHasAccessToLab(checkAccessByPlanId(planId))
  }, [planId])

  function renderBadge() {
    if (Boolean(isThisLabRunning && isLabRunning)) {
      return <StatusBadge isRunning={true} />
    } else if (Boolean(isThisLabLaunching && isLabLaunching)) {
      return <StatusBadge isRunning={false} />
    }
    return null
  }

  return (
    <div className="w-full rounded-md bg-white p-4 font-montserrat flex flex-col justify-between gap-4">
      <div className="space-y-2.5">
        <figure className="w-full aspect-[332/174] object-cover rounded-md overflow-hidden relative">
          <img className="w-full h-full object-cover" src={lab.image} />
          {/* Lab Index Badge */}
          <div className="absolute top-1 left-1 flex items-center gap-1.5 text-xs bg-white/40 backdrop-blur-sm w-fit p-1 rounded font-medium aspect-square">
            {(index + 1).toString().padStart(2, '0')}
          </div>
          {renderBadge()}
        </figure>
        <h2 className="text-md font-semibold text-gray-800">{lab.title}</h2>
      </div>
      <div className="space-y-3.5">
        <div className="flex gap-4 text-xs text-blue/70 border has-[div]:p-2 rounded-md">
          <div className="w-full">
            <p>Total Duration</p>
            <p className="font-semibold">{lab.duration ?? 0} minutes</p>
          </div>
          <div className="w-full">
            <p>Lab Count</p>
            <p className="font-semibold">Unlimited</p>
          </div>
        </div>
        <div className="w-full flex gap-2">
          <button
            onClick={() => navigate(`/subscription/${plan}/${planId}/${moduleID}/${lab._id}`)}
            className=" px-4 py-2 normal-case font-medium rounded-md w-full font-inter text-xs xl:text-sm border border-slate-950 hover:bg-gray-100 duration-300">
            Details
          </button>
          {hasAccessToLab ? (
            <AccessButton name={'Start Lab'} onClick={handleLabClick} />
          ) : (
            <AccessButton name={'Purchase'} onClick={handleNavigateToPricing} />
          )}
        </div>
      </div>
    </div>
  )
}

const AccessButton = ({ name, onClick }) => {
  return (
    <button
      onClick={() => onClick()}
      className=" px-4 py-2 normal-case font-medium text-white rounded-md w-full font-inter text-xs xl:text-sm bg-slate-900">
      {name}
    </button>
  )
}

const StatusBadge = ({ isRunning = false }) => {
  return (
    <div
      className={`absolute top-1 right-1 flex items-center gap-1.5 text-2xs backdrop-blur-sm w-fit p-1 rounded font-medium ${
        isRunning ? 'bg-green-100/10 text-green-900' : 'bg-red/10 text-red'
      }`}>
      {isRunning ? 'Running' : 'Launching'}
      <StatusCircleIcon className="size-2 fill-current" />
      <StatusCircleIcon className="size-2 fill-current absolute right-1 animate-ping" />
    </div>
  )
}

export default SingleLabCard
